import { useEffect } from 'react';
export default function useEventListener(element, type, listener) {
    useEffect(()=>{
        if (!element) {
            return undefined;
        }
        element.addEventListener(type, listener);
        return ()=>{
            element.removeEventListener(type, listener);
        };
    }, [
        element,
        type,
        listener
    ]);
}
